import React from 'react';
import PropTypes from 'prop-types';
import { MomArticle, MomProfilePicture } from './styles';

const MomTestimony = React.forwardRef((props, ref) => {
  return (
    <MomArticle mode="mom" ref={ref}>
      <div className="profile-pic-container">
        <MomProfilePicture src={props.profilePicUrl} alt="" loading="lazy" />
      </div>
      <div className="testimony-content">
        <div className="header">
          <div className="profile">
            <div className="name">{props.name}</div>
            <div>{props.position}</div>
          </div>
        </div>
        <p>{props.description}</p>
      </div>
    </MomArticle>
  );
});

MomTestimony.displayName = 'MomTestimony';

MomTestimony.propTypes = {
  name: PropTypes.string,
  position: PropTypes.string,
  location: PropTypes.string,
  description: PropTypes.string,
  profilePicUrl: PropTypes.string,
  logoUrl: PropTypes.string,
};

export default MomTestimony;
